// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"767":"27eff0887f05949105e4","785":"dc41be7b730d2d8f6ec7"}[chunkId] + ".js";
};